import { render } from "./main_w_put.vue?vue&type=template&id=ad6c120c"
import script from "./main_w_put.vue?vue&type=script&lang=js"
export * from "./main_w_put.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__